<div class="fx-layout-row fx-layout-xs-column fx-layout-sm-column fx-gap-10">
  <div class="fx-flex-100 tree-view-container business-units">
    <label class="root-business-unit">
      Add root business unit
      <a (click)="addRootBusinessUnit()" class="btn-portal-add mr-4" style="padding-left: 10px" pTooltip="Add new business unit" tooltipPosition="left">
        <img src="assets/images/JMicons/JM-icon-15.png" alt="add">
      </a>
    </label>
    <p-tree [value]="treeNodes()" class="no-icons">
      <ng-template let-node pTemplate="default">
        <span class="business-unit-item">
          <input type="text" class="business-unit-name" [(ngModel)]="node.data" (keypress)="onChangeBUText()">
          <a (click)="addBusinessUnit(node)" class="btn-portal-add mr-4 business-unit-button" pTooltip="Add new business unit" tooltipPosition="left">
            <img src="assets/images/JMicons/JM-icon-15.png" alt="add">
          </a>
          @if (!node.children.length) {
            <a (click)="onDelete(node)" class="btn-portal-add mr-4 business-unit-button" pTooltip="Remove business unit" tooltipPosition="left">
              <img src="assets/images/JMicons/JM-icon-21.png" alt="remove">
            </a>
          }
        </span>
      </ng-template>
    </p-tree>
  </div>

</div>
<div class="footer">
  <mat-card-actions align="end" class="fx-layout-row fx-layout-xs-column">
    <!-- <button mat-raised-button color="primary" (click)="onBack()">
    Cancel
  </button> -->
  @if (!isViewOnly) {
    <button mat-raised-button color="primary" [disabled]="!formIsDirty" (click)="saveBusinessUnits()">
      Save
    </button>
  }
</mat-card-actions>
</div>
<app-in-progress [loading]="loadingData"></app-in-progress>